import { Injectable } from '@angular/core';
import { HttpApiService } from '../services/http-api.service';
import { Subject } from 'rxjs';
import { Pagination } from '../utils/interfaces/pagination';

@Injectable({
  providedIn: 'root',
})
export class ReportWinloseService {
  $onSubmit = new Subject<any>();
  $onBackFromDetail = new Subject<any>();

  constructor(private http: HttpApiService) {}

  // ---------- REPORT
  getWinLoseAccountMemberAgent(value: any) {
    return this.http.get<any>(`api/v2/report/winlose-account`, { params: value });
  }
  getWinLoseAccountMemberAgentV2(value: any) {
    return this.http.get<any>(`api/v2/report/winlose-account-v2`, { params: value });
  }
  getWinLoseAccountMemberOnly(value: any) {
    return this.http.get<any>(`api/v2/report/winlose-member`, { params: value });
  }
  getWinLoseAccountMemberDownLine(value: any) {
    return this.http.get<any>(`api/v2/report/winlose-agent-downline`, { params: value });
  }
  getWinloseCompany(params: any) {
    return this.http.get<any>(`api/v2/report/winlose-company`, { params });
  }
  getWinloseCompanyGame(params: any) {
    return this.http.get<any>(`api/v2/report/game/winlose-company`, { params });
  }
  getWinloseCompanyGameType(params: any) {
    return this.http.get<any>(`api/v2/report/game-type/winlose-company`, { params });
  }
  getWinloseCompanyGameProvider(params: any) {
    return this.http.get<any>(`api/v2/report/game-provider/winlose-company`, { params });
  }
  getWinloseCompanyGameCurrency(params: any) {
    return this.http.get<any>(`api/v2/report/game-currency/winlose-company`, { params });
  }

  getWinloseGame(params: any) {
    return this.http.get<any>(`api/v2/report/winlose-game`, { params });
  }

  getWinloseGameType(params: any) {
    return this.http.get<any>(`api/v2/report/winlose-game-type`, { params });
  }

  // ---------- WINLOSE
  getWinloseDetail(params: any) {
    return this.http.get<Pagination<any[]>>(`v2/ag/winlose/detail`, { params });
  }
  getWinloseDetailGame(betId: string, game_type: string) {
    return this.http.get(`v2/ag/winlose/detail/${game_type}`, { params: { betId: betId } });
  }
  getWinloseDetailGameCard(betId: string) {
    return this.http.get(`v2/ag/winlose/detail/game-card`, { params: { betId: betId } });
  }
  getWinloseDetailCasino(betId: string) {
    return this.http.get(`v2/ag/winlose/detail/casino`, { params: { betId: betId } });
  }
  saveWinloseDetailSport(betId: string) {
    return this.http.get(`v2/ag/winlose/detail/save/macth-sport`, { params: { betId: betId } });
  }
  getBetReplay(value: any) {
    return this.http.post(`v2/ag/action/bet-replay`, value);
  }
  putMemberBetlimitSetting(member_id: number, agent_id: number) {
    return this.http.put(
      `api/member/bet_limit/clone?member_id=${member_id}&agent_id=${agent_id}`,
      {}
    );
  }

  requestTransactionWinLoseCasino(betId: string) {
    return this.http.get(`api/v2/report/transaction/winlose-lost-casino?betId=${betId}`);
  }
  requestWinLose(betId: string) {
    return this.http.post(`api/v2/report/transaction-winlose-lost?betId=${betId}`, {});
  }
  sendCallback(betId: string) {
    return this.http.post(`api/v2/report/winlose/send-callback?betId=${betId}`, {});
  }
}

export interface WinLoseProvider {
  game_code_productId: string;
  game_name: string;
  game_type: string;
  amount: number;
  wl_amount: number;
  wl_share_agent: number;
  percent_agent: number;
  wl_share_master_agent: number;
  percent_master_agent: number;
  wl_share_senior_agent: number;
  percent_senior_agent: number;
  wl_share_shareholder: number;
  percent_shareholder: number;
  wl_share_company: number;
  percent_company: number;
  create_dt: string;
  settle_dt: string;
}

export interface WinLoseAccount {
  total_amount: number;
  total_valid_amount: number;
  total_wl_amount: number;
  total_wl_agent_amount: number;
  total_wl_master_agent_amount: number;
  total_wl_senior_agent_amount: number;
  total_wl_shareholder_amount: number;
  total_wl_company_amount: number;
  items: WinLoseAccountItem[];
  resultRow: number;
  currentPage: number;
  limitRow: number;
}

export interface WinLoseAccountItem {
  id: number;
  username: string;
  type_user: string;
  amount: number;
  valid_amount: number;
  wl_amount: number;
  wl_share_agent: number;
  wl_share_master_agent: number;
  wl_share_senior_agent: number;
  wl_share_shareholder: number;
  wl_share_company: number;
  create_dt: string;
  settle_dt: string;
}
export interface PaginationWinlose<T> {
  items: T;
  currentPage: number;
  limitRow: number;
  resultRow: number;
}
export interface ItemWinLoseDetail {
  betId: string;
  Ip: string;
  Provider: string;
  ProviderId: number;
  betAmt: number;
  betValidAmt?: number;
  create_dt: string;
  currency: string;
  gameAction: string;
  gameBetId: any;
  gameLottoType: any;
  gameName: string;
  gameOdds: any;
  gameOddsStyle: any;
  gameProvider: string;
  gameResult: string;
  gameSportsType: any;
  gameStatus: string;
  gameType: string;
  game_session: string;
  member: string;
  memberId: number;
  timeBet: string;
  timeSettle: string;
  winLose: number;
  agent: number;
  percent_agent: number;
  percent_agent_id?: number;
  master: number;
  percent_master: number;
  percent_master_id?: number;
  senior: number;
  percent_senior: number;
  percent_senior_id?: number;
  shareholder: number;
  percent_shareholder: number;
  percent_shareholder_id?: number;
  percent_system: number;
  percent_provider: number;
  company: number;
  percent_company: number;
  winlose_detail_slot_count: number;
  winlose_detail_casino_count: number;
  winlose_detail_game_card_count: number;
  winlose_detail_cockfight_count: number;
  winlose_detail_lotto: any;
  winlose_detail_sports: any;
  winlose_detail_tf: any;
}
